import React ,{ useState } from 'react'
import { sendEmail } from '../components/apifa';
const ContactDetails = () => {
    const [formData, setFormData] = useState({
        fullname: '',
        email: '',
        subject: '',
        number: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await sendEmail(formData);
            alert('Email sent successfully');
        } catch (error) {
            alert('Failed to send email');
        }
    };



    return (



        <section className='p-4 md:p-24'>

            <div className='flex flex-col gap-5'>

                <h1 className='text-myBlue font-bold text-xl md:text-3xl'>Address</h1>

                <h6>F/23, Block 5, Rojhan Street, Clifton, Karachi 75600, Pakistan  </h6>

                <h6>Tel: (+92-21) 35835804-6</h6>

                <h6>Fax: (+92-21) 35830171</h6>

                
                <div className='flex flex-col gap-5'>
                <h1 className='text-myBlue font-bold text-xl md:text-3xl'>For further assistance use the following form</h1>
                <form className='flex flex-col gap-5 md:w-1/3' onSubmit={handleSubmit}>
                    {['fullname', 'email', 'subject', 'number', 'message'].map((field, idx) => (
                        <div key={idx} className='flex flex-col'>
                            <label htmlFor={field}>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                            {field === 'message' ? (
                                <textarea id={field} value={formData[field]} onChange={handleChange} />
                            ) : (
                                <input id={field} type={field === 'email' ? 'email' : field === 'number' ? 'number' : 'text'} value={formData[field]} onChange={handleChange} />
                            )}
                        </div>
                    ))}
                    <button className="bg-black text-white text-xs py-2 px-4 flex items-center justify-center w-16 opacity-80 rounded-md">
                        Send
                    </button>
                </form>
            
                </div>

            </div>

        </section>
    )
}

export default ContactDetails